const HubIcon = () => `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="21" viewBox="0 0 24 21" fill="none">
  <line x1="6" y1="9.25" x2="18" y2="9.25" stroke="white" stroke-width="1.5"/>
  <path d="M1.50612 1.12403L11.7829 19.1085C11.8789 19.2764 12.1211 19.2764 12.2171 19.1085L22.4939 1.12403C22.5891 0.957371 22.4688 0.75 22.2768 0.75H1.72318C1.53122 0.75 1.41088 0.957371 1.50612 1.12403Z" stroke="white" stroke-width="1.5"/>
  </svg>`;
export default HubIcon;
